export const INCOME_COLOR    = '#4ade80';
export const EXPENSE_COLOR   = '#f87171';
export const REPAYMENT_COLOR = '#60a5fa';
export const DEFAULT_CATEGORIES = ['Eating Out','Housing','Utilities','Cars',
  'Health & Wellness','Subscriptions','Entertainment','Groceries',
  'Personal','Income','Accounts & Transfers','Credit Cards','Other'];
